import { GetTripDetailsResponse } from '../../services';
import { AttributeAbbreviation } from '../../services/service-trips-api/types/attribute-abbreviation';

const preferenceKeyMapping: { [key in AttributeAbbreviation]?: string } = {
  [AttributeAbbreviation.ApprovedSoloTravel]: 'approved_solo_travel',
  [AttributeAbbreviation.Assistant]: 'assistant',
  [AttributeAbbreviation.CanTravelByCar]: 'can_travel_by_car',
  [AttributeAbbreviation.ChildSeat]: 'child_seat',
  [AttributeAbbreviation.DoubleStaff]: 'double_staff',
  [AttributeAbbreviation.ElectricWheelchair]: 'electric_walker',
  [AttributeAbbreviation.HandOver]: 'hand_over',
  [AttributeAbbreviation.NeedsBus]: 'needs_bus',
  [AttributeAbbreviation.NeedsFrontSeat]: 'needs_front_seat',
  [AttributeAbbreviation.OkToLeaveAlone]: 'ok_to_leave_alone',
  [AttributeAbbreviation.SeatBeltPillow]: 'seat_belt_pillow',
  [AttributeAbbreviation.Trolley]: 'trolley',
  [AttributeAbbreviation.Walker]: 'walker',
  [AttributeAbbreviation.TransportWheelchair]: 'transport_wheelchair',
  [AttributeAbbreviation.StairLift]: 'stair_lift',
  [AttributeAbbreviation.Wheelchair]: 'wheelchair',
  [AttributeAbbreviation.AllergyVehicle]: 'allergy_vehicle',
  [AttributeAbbreviation.ChildBoosterSeat15To36Kg]:
    'child_booster_seat_15_to_36_kg',
  [AttributeAbbreviation.StationWagon]: 'station_wagon',
  [AttributeAbbreviation.ChildBoosterSeat]: 'child_booster_seat',
  [AttributeAbbreviation.LowCar]: 'low_car',
  [AttributeAbbreviation.OneWheelchair]: 'one_wheelchair',
  [AttributeAbbreviation.ChildBoosterSeat9To18Kg]:
    'child_booster_seat_9_to_18_kg',
  [AttributeAbbreviation.FossilFree]: 'fossil_free',
  [AttributeAbbreviation.FrontSeat]: 'front_seat',
  [AttributeAbbreviation.TramAgreement]: 'tram_agreement',
};

export function getPreferenceLocaleKeys(data: GetTripDetailsResponse | undefined) {
  return data?.attributes
    ?.map(({ abbreviation }) =>
      abbreviation
        ? preferenceKeyMapping[abbreviation as AttributeAbbreviation]
        : undefined
    )
    .filter(Boolean);
}
